import { useMutation, useQueryClient } from '@tanstack/react-query';
import { batchUpdate, getBatchProgress } from '@/services/batch.service';
import { useAuthenticatedQueryFn } from '@/hooks/useAuthenticatedQuery';
import { useBatchStore } from '@/hooks/data/batch/useBatchStore';
import { error as errorLog } from '@/utilities/log';
import { QueryKey } from '@/lib/queryKeys';

export const useBatchUpdateAssets = () => {
  const queryClient = useQueryClient();
  const pollProgress = useBatchStore((state) => state.pollProgress);
  const markBatchErrored = useBatchStore((state) => state.markBatchErrored);

  const batchUpdateAssetsQueryFn = useAuthenticatedQueryFn(batchUpdate);
  const getBatchProgressWithAuth = useAuthenticatedQueryFn(getBatchProgress);

  const { mutateAsync: batchUpdateAssetsMutation } = useMutation<
    { batchId: string },
    Error,
    Parameters<typeof batchUpdate>['0']
  >({
    mutationFn: (params) => batchUpdateAssetsQueryFn(params),
    onSuccess: async (response) => {
      await queryClient.invalidateQueries({ queryKey: [QueryKey.AssetData] });

      const batchId = response.batchId;

      try {
        await pollProgress(batchId, getBatchProgressWithAuth, 'Update assets');
      } catch (err) {
        errorLog(err);
      }
    },
    onError: (err) => {
      markBatchErrored('Update assets');
      errorLog(err);
    },
  });

  return {
    batchUpdateAssetsMutation,
  };
};
